import { Box } from '@material-ui/core';
import { OrderMgmtCard } from '../order-mgmt-card/OrderMgmtCard';
import { OrderMgmtProduct } from '../../../../business/order-mgmt';
import { TimeoutProducts } from '../../timeout';
import OrderMgmtCardStyle from '../order-mgmt-card/OrderMgmtCard.style';

export const OrderMgmtProducts = ({
  products,
  orderId,
  isEnabled = true,
  isTimeoutState,
  orderDetailDescription,
}: Props) => {
  const componentClasses = OrderMgmtCardStyle();

  if (isTimeoutState) {
    return <TimeoutProducts orderDetailDescription={orderDetailDescription} />;
  }
  return (
    <Box overflow='auto' className={componentClasses.container}>
      <Box className={componentClasses.descriptionContainer}>
        {orderDetailDescription}
      </Box>
      {products.map(product => (
        <OrderMgmtCard
          key={`c-${product.id}`}
          product={product}
          orderId={orderId}
          isEnabled={isEnabled}
        />
      ))}
    </Box>
  );
};

interface Props {
  products: Array<OrderMgmtProduct>;
  orderId: number;
  isEnabled?: boolean;
  isTimeoutState: boolean;
  orderDetailDescription: string;
}
